import { render } from "./about.vue?vue&type=template&id=80fbab3e&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=80fbab3e&lang=scss&scoped=true"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fbab3e"]])

export default __exports__